import React from "react";
import {
  Box,
  Typography,
  Button,
  TextField,
  CircularProgress,
  Paper,
  Grid,
  Avatar
} from "@material-ui/core";
import {
  Star as StarIcon,
  StarBorder as StarBorderIcon,
  CloseOutlined
} from "@material-ui/icons";
import { withStyles, createStyles, Theme } from "@material-ui/core/styles";
import ReviewsController, { Props } from "./ReviewsController";
import { Rating } from "@material-ui/lab";
import PhoneInput from "react-phone-input-2";
import { webStyles } from "../../../framework/src/enduserTheme";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "column",
      height: "auto",
      overflow: "auto",
      padding: theme.spacing(2),
      paddingTop: "50px"
    },
    header: {
      padding: theme.spacing(2),
      backgroundColor: theme.palette.background.paper,
      position: "sticky",
      top: 0,
      zIndex: 1
    },
    backButton: {
      marginRight: theme.spacing(1)
    },
    content: {
      flex: 1,
      display: "flex",
      flexDirection: "column",
      padding: theme.spacing(2),
      overflowY: "auto",
      WebkitOverflowScrolling: "touch",
      margin: "0 auto",
      // width: "100%",
      maxWidth: "600px",
      // paddingBottom: "100px", // Space for the fixed button
      overflowX: "hidden"
    },
    ratingContainer: {
      textAlign: "center",
      "& .MuiRating-iconEmpty": {
        color: "#000"
      },
      "& .MuiRating-iconFilled": {
        color: "#FFC629"
      },
      "& .MuiRating-icon": {
        fontSize: "3.5rem"
      }
    },
    textArea: {
      margin: `${theme.spacing(3)}px 0`,
      "& .MuiOutlinedInput-multiline": {
        padding: theme.spacing(2)
      },
      "& .MuiInputLabel-outlined": {
        fontSize: "13px"
      },
      "& .MuiInputBase-root": {
        borderRadius: "8px",
        "&:hover .MuiOutlinedInput-notchedOutline": {
          borderColor: "#FFC629"
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
          borderColor: "#FFC629"
        }
      }
    },
    nameInput: {
      margin: `${theme.spacing(3)}px 0`,
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          border: "none"
        },
        "&:hover fieldset": {
          border: "none"
        },
        "&.Mui-focused fieldset": {
          border: "none"
        },
        "& .MuiInputBase-input": {
          fontSize: "20px",
          fontWeight: 600
        }
      },
      "& .MuiInputLabel-outlined": {
        fontSize: "13px"
      },
      "& .MuiInputBase-root": {
        borderRadius: "8px"
      }
    },
    phoneInput: {
      margin: `${theme.spacing(3)}px 0`,
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          border: "none"
        },
        "&:hover fieldset": {
          border: "none"
        },
        "&.Mui-focused fieldset": {
          border: "none"
        },
        "& .MuiInputBase-input": {
          fontSize: "20px",
          fontWeight: 600
        }
      }
    },
    otpContainer: {
      display: "flex",
      justifyContent: "space-between",
      margin: `${theme.spacing(3)}px 0`,
      "& .MuiTextField-root": {
        width: "15%",
        textAlign: "center"
      }
    },
    successContainer: {},
    submitButton: {
      marginTop: theme.spacing(3),
      width: "100%",
      borderRadius: 20,
      backgroundColor: "#000",
      "&:hover": {
        backgroundColor: "#000"
      },
      "& span": {
        color: "#fff",
        textTransform: "none"
      }
    },
    otpInput: {
      "&:not(:last-child)": {
        marginRight: "8px"
      }
    },
    rating: {
      display: "flex",
      alignItems: "center",
      "& .MuiRating-icon": {
        color: "#FFC107",
        fontSize: "16px"
      }
    },
    reviewContent: {
      padding: "16px !important"
    },
    userName: {
      fontSize: "13px",
      color: "rgb(72 115 165)",
      lineHeight: "20px",
      fontWeight: "bold"
    },
    avatar: {
      color: "#000",
      backgroundColor: "#f1d17885",
      border: "3px solid #f4b914",
      borderRadius: "50%"
    },
    reviewText: {
      marginTop: "4px",
      fontSize: "13px",
      color: "#333333",
      lineHeight: "16px"
    }
  });

class AddReview extends ReviewsController {
  constructor(props: Props) {
    super(props);
    // Customizable Area Start
    // Customizable Area End
  }

  renderHeader() {
    const { classes } = this.props;

    return (
      <Paper className={classes.header} elevation={0}>
        <Grid container justifyContent="flex-end" alignItems="center">
          <Button
            className={classes.sortButton}
            onClick={() =>
              // this.state.currentStep === 0
              //   ? this.handleRedirect("Reviews")
              //   : this.prevStep()
              this.handleRedirect("Reviews")
            }
            startIcon={<CloseOutlined className={classes.sortIcon} />}
            style={{ justifyContent: "flex-end" }}
          />
        </Grid>
      </Paper>
    );
  }
  renderStepContent(step: number) {
    const { classes } = this.props;
    const { rating, description, userName, phoneNumber, otpCode, otpError, phoneError } = this.state;

    switch (step) {
      case 0:
        return (
          <div className={classes.ratingContainer}>
            <Rating
              value={rating}
              onChange={(_, value) => this.setRating(value || 0)}
              size="large"
              icon={<StarIcon style={{ color: "#FFC629", fontSize: "40px" }} />}
              emptyIcon={
                <StarBorderIcon
                  style={{ color: "#FFD86B", fontSize: "40px" }}
                />
              }
            />
            <TextField
              className={classes.textArea}
              multiline
              minRows={6}
              maxRows={6}
              variant="outlined"
              fullWidth
              value={description}
              onChange={e => this.setState({ description: e.target.value })}
              placeholder="Share your personal experience"
            />
          </div>
        );
      case 1:
        return (
          <div className={classes.ratingContainer}>
<Rating
  value={rating}
  onChange={(_, value) => this.setRating(value || 0)}
  size="large"
  icon={
    <StarIcon
      style={{
        color: "#FFC629", // solid yellow when selected
        fontSize: "40px"
      }}
    />
  }
  emptyIcon={
    <StarBorderIcon
      style={{
        color: "#000", // black outline when not selected
        fontSize: "40px"
      }}
    />
  }
/>
            <TextField
              className={classes.textArea}
              multiline
              minRows={6}
              maxRows={6}
              variant="outlined"
              fullWidth
              value={description}
              onChange={(e) =>
                this.setState({ description: e.target.value })
              }
              placeholder="Share your personal experience"
            />
            <Typography variant="caption" gutterBottom>
              {`Great start! Let's add a personal touch to your review. What's your first and last name?`}
            </Typography>
            <TextField
              className={classes.nameInput}
              variant="outlined"
              fullWidth
              value={this.state.userName}
              onChange={(e) => {
                const value = e.target.value;

                const cleaned = value.replace(/\s+/g, " ");

                const words = cleaned.trim().split(" ").filter(Boolean);

                if (words.length <= 2) {
                  this.setState({ userName: cleaned });
                }
              }}
              placeholder="Enter your name"
            />
          </div>
        );
      case 2:
        return (
          <div className={classes.ratingContainer}>
            <Rating
              value={rating}
              onChange={(_, value) => this.setRating(value || 0)}
              size="large"
              icon={<StarIcon style={{ color: "#FFC629", fontSize: "40px" }} />}
              emptyIcon={
                <StarBorderIcon
                  style={{ color: "#FFD86B", fontSize: "40px" }}
                />
              }
            />
            <TextField
              className={classes.textArea}
              multiline
              minRows={6}
              maxRows={6}
              variant="outlined"
              fullWidth
              value={description}
              onChange={e => this.setState({ description: e.target.value })}
              placeholder="Share your personal experience"
            />
            <Typography variant="caption" gutterBottom>
              {`We never share this with anyone and it won't be on your profile.`}
            </Typography>
            <Typography variant="caption" gutterBottom>
              {`We'll only verify your number to ensure you are you.`}
            </Typography>
            <PhoneInput
              data-test-id="userNumber"
              country={"us"}
              value={phoneNumber}
              onChange={value =>
                this.setState({ phoneNumber: value, phoneError: "" })
              }
              placeholder={"Add Your Phone number"}
              specialLabel={""}
              buttonStyle={webStyles.buttonStyleLight}
              inputStyle={webStyles.phoneInputLight}
              containerClass={classes.phoneInput}
            />
            {phoneError && (
              <Typography
                variant="caption"
                gutterBottom
                style={{ color: "#f44336" }}
              >
                {phoneError}
              </Typography>
            )}
            <Typography variant="caption" gutterBottom>
              {`By tapping "continue" you agree to our privacy policy and  terms of service and authorize Everybrand to send you text message to the mobile number provided. Message/data rates may apply.`}
            </Typography>
          </div>
        );
      case 3:
        return (
          <div className={classes.ratingContainer}>
            <Rating
              value={rating}
              onChange={(_, value) => this.setRating(value || 0)}
              size="large"
              icon={<StarIcon style={{ color: "#FFC629", fontSize: "40px" }} />}
              emptyIcon={
                <StarBorderIcon
                  style={{ color: "#FFD86B", fontSize: "40px" }}
                />
              }
            />
            <TextField
              className={classes.textArea}
              multiline
              minRows={6}
              maxRows={6}
              variant="outlined"
              fullWidth
              value={description}
              onChange={e => this.setState({ description: e.target.value })}
              placeholder="Share your personal experience"
            />
            <Typography variant="caption" gutterBottom>
              Enter the code we sent to +1 {phoneNumber}
            </Typography>
            <div className={classes.otpContainer}>
              {this.inputRefs.map((inputRef: any, index: number) => (
                <TextField
                  key={index}
                  data-test-id={`codeInput-${index}`}
                  autoFocus={index === 0}
                  inputRef={inputRef}
                  value={otpCode[index] || ""}
                  onChange={e => this.handleOtpChange(e, index)}
                  variant="outlined"
                  className={classes.otpInput}
                  inputProps={{
                    maxLength: 1,
                    style: { textAlign: "center" }
                  }}
                  onKeyDown={e => this.handleOtpKeyDown(e, index)}
                />
              ))}
            </div>
            {otpError && (
              <Typography variant="caption" gutterBottom style={{ color: "#f44336" }}>
                {otpError}
              </Typography>
            )}
            <Button
              color="primary"
              onClick={this.prevStep}
              disabled={this.state.isResending}
            >
              {"Change the phone number"}
            </Button>
          </div>
        );
      case 4:
        return (
          <div className={classes.successContainer}>
            <Box className={classes.reviewContent}>
              <Box
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 8
                }}
              >
                <Avatar alt={userName} className={classes.avatar}>
                  {userName ? userName.charAt(0).toUpperCase() : "UN"}
                </Avatar>
                <Box className={classes.userInfo}>
                  <Box display="flex" alignItems="center" style={{ gap: 3 }}>
                    <Typography className={classes.userName}>
                      {userName || "User Name"}
                    </Typography>
                    <Box className={classes.rating}>
                      <Rating
                        value={rating}
                        readOnly
                        precision={0.5}
                        icon={<StarIcon fontSize="inherit" />}
                        emptyIcon={
                          <StarBorderIcon
                            fontSize="inherit"
                            style={{ color: "rgb(72 115 165)" }}
                          />
                        }
                        size="small"
                      />
                    </Box>
                  </Box>
                  <Typography className={classes.reviewText}>
                    {description || "Your review text will appear here..."}
                  </Typography>
                </Box>
              </Box>
            </Box>
            <Typography
              variant="caption"
              color="textSecondary"
              paragraph
              style={{ padding: "16px", marginTop: "36px" }}
            >
              Congratulations! Your profile has been created. Once the button
              below to your community can see your Review.
            </Typography>
          </div>
        );
      default:
        return "Unknown step";
    }
  }

  render() {
    const { classes } = this.props;
    const { currentStep, isSubmitting } = this.state;

    return (
      <>
        {/* { this.renderHeader() } */}
        <div className={classes.root}>
          {this.renderStepContent(currentStep)}
          <Box
            style={{
              padding: "16px",
              backgroundColor: "#fff"
            }}
          >
            <Button
              variant="contained"
              color="primary"
              // onClick={currentStep === 4 ? this.submitReview : this.nextStep}
              onClick={()=>this.handleContinue()}
              disabled={isSubmitting}
              fullWidth
              className={classes.submitButton}
            >
              {isSubmitting ? (
                <CircularProgress size={24} color="inherit" />
              ) : currentStep === 4 ? (
                "Post"
              ) : (
                "Continue"
              )}
            </Button>
          </Box>
        </div>
      </>
    );
  }
}

export default withStyles(styles)(AddReview);
